<template>
    <div>
        <div class="receipt-seal-info">
            <h3>签回要求</h3>
            <div class="image-box">
                <div style="height: 190px" v-if="receiptSealInfo.files.length">
                    <ul id="sealViewer" style="display: none">
                        <li v-for="(item, index) in receiptSealInfo.files" :key="index">
                            <img :src="item.path" />
                        </li>
                    </ul>
                </div>
                <div v-if="receiptSealInfo.files.length" class="indexShow">{{ carouselIndex + 1 + ' / ' + receiptSealInfo.files.length }}</div>
                <div v-else class="el-carousel-image" style="line-height: 200px;">暂 无 图 片 信 息 数 据</div>
            </div>
            <p class="days">
                <span>回单时效类型：</span>
                <span class="agingType">{{+receiptSealInfo.agingType === 1 ? '自然月' : '固定天数' }}</span>
                签回时效：
                <span class="text-red">{{ receiptSealInfo.aging }}天</span>
                <el-tooltip class="item" effect="dark" content="按要求上传回单，可以提升结算回款及时率" placement="right">
                    <i class="el-icon-info el-icon-red"></i>
                </el-tooltip>
            </p>
        </div>
        <div class="tags">
            <el-tag
                type="warning"
                size="medium"
                v-for="(item, index) in receiptSealInfo.signRequest"
                :key="index">{{ item }}
            </el-tag>
        </div>
        <div class="sign-ask-stamp">
            <p style="line-height: 1.5">
                回单类型：<span class="text-red"> {{ receiptSealInfo.receiptTypeName || '--' }} </span><br/>
                章类型：<span class="text-red">{{ receiptSealInfo.stampCompanyTypes || '--' }}</span><br/>
                盖章公司名：<span class="text-red">{{ receiptSealInfo.stampCompanyNames || '--' }}</span><br/>
            </p>
        </div>
    </div>
</template>
<script>
import Viewer from 'viewerjs';
export default {
    name: 'signAsk',
    props: {
        receiptSealInfo: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            carouselIndex: 0, // 当前图片索引
            sealViewer: {}
        };
    },
    methods: {
        /**
         * @description 切换图片时，更新图片上传信息
         * @param {Number} index 当前显示图片索引
         */
        updateInfo (index) {
            this.carouselIndex = index;
        },

        // 初始化viewer组件
        initViewer () {
            if (this.receiptSealInfo.files.length > 0) {
                const barOptions = { show: true, size: 'default' };
                this.sealViewer = new Viewer(document.getElementById('sealViewer'), {
                    title: false,
                    inline: true,
                    navbar: true,
                    focus: false, // 关闭页面自动定位到viewer
                    backdrop: true, // 透明背景色
                    zoomOnWheel: true, // 滚动缩放
                    toolbar: {
                        zoomIn: barOptions,
                        zoomOut: barOptions,
                        oneToOne: barOptions,
                        reset: barOptions,
                        prev: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === 0) {
                                    return this.$message.warning('当前图片是第一张');
                                } else {
                                    this.carouselIndex -= 1;
                                    this.sealViewer.prev(true);
                                }
                            }
                        },
                        play: barOptions,
                        next: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === this.receiptSealInfo.files.length - 1) {
                                    return this.$message.warning('当前图片是最后一张');
                                } else {
                                    this.carouselIndex += 1;
                                    this.sealViewer.next(true);
                                }
                            }
                        },
                        rotateLeft: barOptions,
                        rotateRight: barOptions,
                        flipHorizontal: barOptions,
                        flipVertical: barOptions

                    },
                    viewed: data => { // 图片加载完成时回调
                        this.updateInfo(data.detail.index);
                        if (this.fullscreenFlag) {
                            this.sealViewer.moveTo(0, 50);
                        }
                    }
                });
            }
        }
    },
    mounted () {
        this.sealViewer.element && this.sealViewer.destroy(); // 删除viewer上一次的实例
        this.$nextTick(() => {
            this.initViewer();
        });
    }
};
</script>
<style lang="less">
.receipt-seal-info {
    h3 {
        margin-bottom: 5px;
    }
    .image-box {
        height: 200px;
        // border: 1px solid #ddd;
        border-radius: 6px;
        text-align: center;
        padding: 10px 0;
        .indexShow {
            margin-top: 3px;
        }
        .el-carousel-image {
            height: 180px;
            width: 160px;
            display: inline-block;
            .image-item {
                width: 100%;
                height: 100%
            }
        }
        .tools-bar {
            margin-top: 8px;
            .icon {
                font-size: 16px;
                padding: 0 5px;
                cursor: pointer;
            }
        }
    }
    .days {
        text-align: center;
        font-size: 13px;
        margin: 0px auto 10px;
        .text-red {
            color: #F56C6C;
        }
        .el-icon-red {
            padding-left: 10px;
            color: #F56C6C;
            font-size: 16px;
        }
        .agingType{
            margin-right: 10px;
            color: #F56C6C;
        }
    }
}
.tags {
    width: 315px;
    text-align: center;
    span {
        margin-right: 10px;
        margin-bottom: 4px;
    }
    .el-tag {
        padding: 0 6px;
    }
}
.sign-ask-stamp {
    text-align: center;
    font-size: 13px;
    .mgl-10 {
        margin-left: 10px;
    }
    .text-red {
        color: #F56C6C;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
